import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoTalentoHumano({ idSolicitud, onCreated }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [area, setArea] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");
  const [antiguedad, setAntiguedad] = useState("");

  const postData = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaEquipoTalentoHumano",
        {
          nombre,
          area,
          cargo,
          lider,
          antiguedad,
          SolicitudId: idSolicitud,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      alert("Registro creado correctamente");

      onCreated && onCreated();

      setIsOpen(false);
      setNombre("");
      setArea("");
      setCargo("");
      setLider("");
      setAntiguedad("");
    } catch (error) {
      console.error(error);
      alert("Error al crear registro");
    }
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Nuevo
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <br></br>
        <br></br>
        <h5 className="mb-3">Crear Equipo Talento Humano</h5>

        <form onSubmit={postData}>
          <input
            className="form-control mb-2"
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />

          <input
            className="form-control mb-2"
            placeholder="Área"
            value={area}
            onChange={(e) => setArea(e.target.value)}
            required
          />

          <input
            className="form-control mb-2"
            placeholder="Cargo"
            value={cargo}
            onChange={(e) => setCargo(e.target.value)}
            required
          />

          <select
            className="form-control mb-3"
            value={lider}
            onChange={(e) => setLider(e.target.value)}
            required
          >
            <option value="">¿Es líder?</option>
            <option value="Si">Sí</option>
            <option value="No">No</option>
          </select>
          <input
            className="form-control mb-2"
            placeholder="Años de antiguedad"
            value={antiguedad}
            onChange={(e) => setAntiguedad(e.target.value)}
          />
          <button className="btn btn-primary w-100">Guardar</button>
        </form>
      </ReactModal>
    </>
  );
}

export default CreaEquipoTalentoHumano;
